import { feedbackApi } from "@/api/feedback";
import { replace } from "@/utils/vue";
import { defineStore } from "pinia";
import { reactive } from "vue";

export const useFeedbackStore = defineStore('feedback', () => {

  const polls = reactive<{ id: string, date: number }[]>([])

  const requestPolls = async () => {
    const resp = await feedbackApi.getPolls()
    replace(polls, resp)
  }
  const createPoll = async () => {
    const resp = await feedbackApi.createPoll()
    polls.unshift(resp)
  }

  return {
    polls,
    requestPolls,
    createPoll
  }

})